import { createSlice } from '@reduxjs/toolkit';
import { isAcceptanceTest, isDev } from 'in-meeting-experience-ui-components/utils/general';
import { getSessionStorageItem, removeSessionStorageItem } from 'in-meeting-experience-ui-components/utils/sessionStotage';
import { createTracker as noAuthTracker } from 'usage-tracker-public';
import events from '../../../events.yaml';
import { SESSION_STORAGE_EVENTS_KEY } from '../../constants/tracking';
import { appendItemToSessionStorageArray } from '../../utils/sessionStotage';
const initialState = {
  tracker: noAuthTracker({
    events,
    properties: {
      namespace: 'google-meet-add-on-ui',
      email: null,
      hubId: null,
      lang: null,
      hstc: null,
      host: true,
      pastMeeting: false,
      ousideMeeting: false
    },
    debug: isDev,
    bypassPool: true
  }),
  isReady: false
};
const tracker = createSlice({
  name: 'tracker',
  initialState,
  reducers: {
    setTrackerProperies: (state, action) => {
      state.tracker.setProperties(action.payload);
    },
    triggerReadyState: state => {
      const savedEvents = getSessionStorageItem(SESSION_STORAGE_EVENTS_KEY) || [];
      if (savedEvents.length) {
        savedEvents.forEach(item => {
          const [key, value] = Object.entries(item)[0];
          if (isAcceptanceTest) {
            console.warn(`%c track queue event ${key}:`, 'background: #89fb4c; color: #093793', value);
          } else {
            state.tracker.track(key, value);
          }
        });
      }
      removeSessionStorageItem(SESSION_STORAGE_EVENTS_KEY);
      state.isReady = true;
    },
    trackPageView: (state, action) => {
      if (isAcceptanceTest) {
        console.warn(`%c trackPageView ${new Date().toISOString()}:`, 'background: #89fb4c; color: #093793', action.payload);
        return;
      }
      if (state.isReady) {
        state.tracker.track('pageView', {
          screen: action.payload
        });
      } else {
        appendItemToSessionStorageArray(SESSION_STORAGE_EVENTS_KEY, {
          pageView: {
            screen: action.payload
          }
        });
      }
    },
    trackInteraction: (state, action) => {
      if (isAcceptanceTest) {
        console.warn(`%c trackInteraction ${new Date().toISOString()}:`, 'background: #89fb4c; color: #093793', action.payload);
        return;
      }
      if (state.isReady) {
        state.tracker.track('interaction', action.payload);
      } else {
        appendItemToSessionStorageArray(SESSION_STORAGE_EVENTS_KEY, {
          interaction: action.payload
        });
      }
    },
    trackUsage: (state, action) => {
      if (isAcceptanceTest) {
        console.warn(`%c trackUsage ${new Date().toISOString()}:`, 'background: #89fb4c; color: #093793', action.payload);
        return;
      }
      if (state.isReady) {
        state.tracker.track('usage', action.payload);
      } else {
        appendItemToSessionStorageArray(SESSION_STORAGE_EVENTS_KEY, {
          usage: action.payload
        });
      }
    }
  }
});
export const trackerActions = tracker.actions;
export default tracker.reducer;